export const ADD_IMAGES_SURVEYS = 'ADD_IMAGES_SURVEYS';
export const DELETE_IMAGES_SURVEYS = 'DELETE_IMAGES_SURVEYS';
